import { isValidIPv6 } from '@ipfabric/ui-components/IPSubnetInput/helpers/ipAddressValidations';
import ip from 'ip';
import { isValidIp } from 'utils/formValidation/validations';

export const isMulticastAddress = (value: string): boolean => {
  // Multicast range is 224.0.0.0/4
  const mcastNetlong = 3758096384; // long represenation of 224.0.0.0 => network address
  const mcastBroadLong = 4026531839; // long represenation of 239.255.255.255 => broad cast address
  try {
    if (isValidIp(value)) {
      const ipLong = ip.toLong(value);
      return ipLong >= mcastNetlong && ipLong <= mcastBroadLong;
    }

    // IPv6 single address or CIDR - anything starting `ffxx::` is multicast
    if (isValidIPv6(value)) {
      return /^ff[0-9a-f]{2}/i.test(value);
    }

    // IPv4 CIDR
    const { networkAddress, broadcastAddress } = ip.cidrSubnet(value);
    const netLong = ip.toLong(networkAddress);
    const broadLong = ip.toLong(broadcastAddress);
    return netLong >= mcastNetlong && broadLong <= mcastBroadLong;
  } catch {
    return false;
  }
};
